// 계정(아이디/세션) 관련 공용 규칙 — 서버 검증과 클라이언트 인라인 검증이 같은 소스를 쓴다.

// 아이디: 영문 소문자/숫자, 4~20자
export const USERNAME_RE = /^[a-z0-9]{4,20}$/;
export function isValidUsername(name: unknown): name is string {
  return typeof name === "string" && USERNAME_RE.test(name);
}
export const USERNAME_RULE_MSG = "아이디는 영문 소문자/숫자 4~20자여야 합니다";

// 중복 접속 차단 (새 로그인 우선) — 서버가 기존 클라이언트를 이 코드로 끊는다.
export const DUPLICATE_LOGIN_LEAVE_CODE = 4001;
export const DUPLICATE_LOGIN_MSG = "다른 기기에서 접속되어 연결이 종료되었습니다.";
